export interface SubFooterLink {
  label: string;
  href: string;
}

export interface FooterColumn {
  header: string;
  position: number;
  footerType: string;
  links: Array<{
    name: string;
    url: string;
    position: number;
  }>;
}

export const getFooterData = (
  _configurations,
  sectionLabel = 'Section',
  generalLabel = 'General'
): {
  section: FooterColumn[];
  general: FooterColumn[];
} => {
  // Group links by column and footer type
  const columnMap = new Map<string, FooterColumn>();

  _configurations?.forEach((link) => {
    const key = `${link.columnPosition}-${link.footerType}`;

    if (!columnMap.has(key)) {
      columnMap.set(key, {
        header: link.columnHeaderName,
        position: Number(link.columnPosition),
        footerType: link.footerType,
        links: [],
      });
    }

    const column = columnMap.get(key)!;
    column.links.push({
      name: link.linkName,
      url: link.linkUrl,
      position: Number(link.linkPosition),
    });
  });

  // Sort links within each column and sort columns by position
  const allColumns = Array.from(columnMap.values())
    .map((column) => ({
      ...column,
      links: column.links.sort((a, b) => a.position - b.position),
    }))
    .sort((a, b) => a.position - b.position);

  // Match footerType against both English and translated labels to handle
  // locale-specific CMS data (e.g. Spanish "Sección" vs English "Section")
  const sectionLabels = new Set([sectionLabel, 'Section']);
  const generalLabels = new Set([generalLabel, 'General']);

  return {
    section: allColumns.filter((col) => sectionLabels.has(col.footerType)),
    general: allColumns.filter((col) => generalLabels.has(col.footerType)),
  };
};
